/**
 * Shared Programme / Portfolio list filters for Partners hub channels.
 * Query params: agreement=all|signed|missing (default all), status=active|all (default active).
 */

export const AGREEMENT_OPTIONS = [
  { value: 'all', label: 'All firms' },
  { value: 'signed', label: 'Signed agreements only' },
  { value: 'missing', label: 'Missing agreement only' },
];

export const STATUS_OPTIONS = [
  { value: 'active', label: 'Active firms' },
  { value: 'all', label: 'Include closed' },
];

export const REASON_LABELS = {
  missing_agreement: 'Missing agreement',
  dormant: 'Dormant',
  bank_unverified: 'Bank unverified',
  tax_incomplete: 'Tax incomplete',
  self_billing_incomplete: 'Self-billing incomplete',
  payout_awaiting_funding: 'Payout awaiting funding',
  payout_failed: 'Payout failed',
};

/**
 * @param {URLSearchParams} params
 * @returns {{ agreement: string, status: string }}
 */
export const readListFilters = (params) => {
  const agreement = ['all', 'signed', 'missing'].includes(params.get('agreement'))
    ? params.get('agreement')
    : 'all';
  const status = ['active', 'all'].includes(params.get('status')) ? params.get('status') : 'active';
  return { agreement, status };
};

/**
 * Format ISO date as dd/MM/yy for Portfolio "Agreement signed" column.
 * @param {string|null|undefined} iso
 * @returns {string|null}
 */
export const formatAgreementSigned = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const dd = String(d.getUTCDate()).padStart(2, '0');
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const yy = String(d.getUTCFullYear()).slice(-2);
  return `${dd}/${mm}/${yy}`;
};

/**
 * Human label for an engagement / worklist reason code.
 * @param {string} reason
 */
export const reasonLabel = (reason) => REASON_LABELS[reason] || String(reason || '').replace(/_/g, ' ');
